/** Invoice routes. */
import { InvoicesListPage } from "./InvoiceList.js";
import { InvoiceNewPage } from "./InvoiceNew.js";
import { InvoiceDetailPage } from "./InvoiceDetail.js";

export const invoicesRoutes = [
  { path: "invoices", element: <InvoicesListPage /> },
  { path: "invoices/new", element: <InvoiceNewPage /> },
  { path: "invoices/:id", element: <InvoiceDetailPage /> },
];
